export default "__VITE_ASSET__C2M5yapb__"